module.exports = __webpack_public_path__ + "img/23.38ac3549.gif";